var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatwWayDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#D3D8DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 135.7H44.1C41.3 135.7 39 133.4 39 130.6V69.1C39 66.3 41.3 64 44.1 64H156.5C159.3 64 161.6 66.3 161.6 69.1V130.6C161.6 133.5 159.3 135.7 156.5 135.7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.6 79.5H39V88.5H161.6V79.5Z",
    fill: "#BCBFC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.8 126.797H137.2C136 126.797 135 125.797 135 124.597V114.497C135 113.297 136 112.297 137.2 112.297H153.8C155 112.297 156 113.297 156 114.497V124.597C156 125.897 155 126.797 153.8 126.797Z",
    fill: "#BCBFC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6 123.703H45.5V126.803H84.6V123.703Z",
    fill: "#BCBFC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1 116.5H45.5V119.6H65.1V116.5Z",
    fill: "#BCBFC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatwWayDefault);
export default __webpack_public_path__ + "static/media/gatwWayDefault.b6971346c52cd657c12a195c6ed4dc52.svg";
export { ForwardRef as ReactComponent };